import React, { useState } from "react";
import { Button } from "../../ui";
import { FormControlLabel, Checkbox } from "@mui/material";
import useMobile from "../../hooks/useOrientation";
import { warning } from "../../ui/colors";
import Second from "../album/steps/Second";
import Third from "../album/steps/Third";
import { CircularProgress } from "@mui/material";
import { database } from "../../config";
import { addDoc, collection } from "firebase/firestore";

const HoodieScreen = () => {
  const [step, setStep] = useState(1);
  const isMobile = useMobile();

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState();
  const [hoodieData, setHoodieData] = useState({
    Nombre_Padres: "",
    Apellido_Padres: "",
    Telefono_Padres: "",
    Nombre_Pasajero: "",
    Apellido_Pasajero: "",
    Cedula_Pasajero: "",
    Numero_Bus: "",
    Color_Buzo: "",
    Disenio_Espalda: "",
    Talle: "",
  });
  const [alsoWantAlbum, setAlsoWantAlbum] = useState(false);

  const moveForward = async () => {
    setErrorMessage("");
    if (step === 1) {
      const {
        Nombre_Padres,
        Apellido_Padres,
        Telefono_Padres,
        Nombre_Pasajero,
        Apellido_Pasajero,
        Cedula_Pasajero,
        Numero_Bus,
      } = hoodieData;
      if (
        stringNotEmpty(Nombre_Padres) &&
        stringNotEmpty(Apellido_Padres) &&
        stringNotEmpty(Telefono_Padres) &&
        stringNotEmpty(Nombre_Pasajero) &&
        stringNotEmpty(Apellido_Pasajero) &&
        stringNotEmpty(Cedula_Pasajero) &&
        stringNotEmpty(Numero_Bus) &&
        stringNotEmpty(hoodieData.Color_Buzo) &&
        stringNotEmpty(hoodieData.Disenio_Espalda) &&
        stringNotEmpty(hoodieData.Talle)
      ) {
        setErrorMessage("");
        setLoading(true);
        setStep(step + 1);
        await addDoc(collection(database, "buzo2026"), hoodieData);
        if (alsoWantAlbum) {
          await addDoc(collection(database, "album2026"), hoodieData);
        }
      } else {
        setErrorMessage("Se deben completar todos los campos.");
      }
    } else {
      setStep(step + 1);
    }
  };

  const stringNotEmpty = (word) => {
    return word;
  };

  const getComponentStep = () => {
    switch (step) {
      case 1:
        return (
          <Second
            data={hoodieData}
            onChangeData={(data) => setHoodieData(data)}
            hoodieFields={true}
          />
        );
      case 2:
        return <Third />;
      default:
    }
  };

  const isLastStep = step === 2;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <h2 style={{ textAlign: "center", marginTop: 16 }}>Reservá tu buzo!</h2>
      <div
        style={{
          width: "100%",
          alignItems: "center",
        }}
      >
        {getComponentStep()}
        {step === 1 && (
          <div
            style={{ display: "flex", justifyContent: "center", marginTop: 16 }}
          >
            <FormControlLabel
              control={
                <Checkbox
                  checked={alsoWantAlbum}
                  onChange={(e) => setAlsoWantAlbum(e.target.checked)}
                  color="primary"
                />
              }
              label="También quiero mi álbum"
            />
          </div>
        )}
      </div>
      {step === 1 && (
        <h4 style={{ color: warning, alignSelf: "center" }}>{errorMessage}</h4>
      )}
      <div
        style={{
          alignSelf: "center",
          textAlign: "center",
          padding: 10,
        }}
      >
        <div style={{ display: "flex", flexDirection: "column" }}>
          {!isLastStep ? (
            <div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: 10,
                }}
              >
                <Button
                  customStyles={{
                    margin: 5,
                    alignSelf: isMobile ? "center" : null,
                  }}
                  variant="contained"
                  onClick={moveForward}
                >
                  <h3 style={{ margin: 0 }}>Terminar</h3>
                </Button>
              </div>
              {loading ? <CircularProgress /> : null}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default HoodieScreen;
